import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { Button, Typography } from '@mui/material';
import {Props as definitionSectionProps} from '~common/form/definition-section';
import PortalUserContext from '~common/lib/portal-user-context';
import Renderers from '~common/lib/renderers';
import ProxyFeatureAssignment from '~users/components/proxy-feature-assignment-view'
import EmptySet from "~common/components/empty-set"

const styles = (theme: Theme): StyleRules => ({
  container: {
    // width: '100%'
    paddingLeft: 15
  },
  addNewProxyButton: {
    marginTop: 10
  }
});

// props extended from definition-section
interface Props extends definitionSectionProps {

}

type State = {

};

class FeatureProxyAssignment extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
    
    };
  }

  static register = () => {
    // console.log("Registering proxyAssignmentView")
    if (!Renderers.find("proxyAssignmentView")) {
          // console.log("Registering proxyAssignmentView")
        Renderers.register("proxyAssignmentView", withStyles(styles)(FeatureProxyAssignment))
    }
}

componentDidMount() {
    // console.log("FeatureProxyAssignment props", this.props)
    this.setState({
       
    })
}

onProxyChange = (proxy: any) => {
  // console.log("onProxyChange", proxy)
    var {onChangeAtPath} = this.props
    var {data} = this.props
    if (data.proxies) {

      if (proxy.id) {
        var proxyIndex = data.proxies.findIndex((p:any)=>{
          return p.id == proxy.id
        })
        // console.log("proxyIndex", proxyIndex)
        if (proxyIndex > -1) {
            data.proxies[proxyIndex] = proxy
        }   
      }
     
      if (proxy._id) {
        var proxyIndex = data.proxies.findIndex((p:any)=>{
          return p._id == proxy._id
        })
        // console.log("proxyIndex", proxyIndex)
        if (proxyIndex > -1) {
          data.proxies[proxyIndex] = proxy
        }
      }
    }

    onChangeAtPath("/proxyInfo", data)
}

newProxy = () => {
  var {onChangeAtPath} = this.props
  var {data} = this.props
  if (data.proxies) {
    data.proxies.push({_id: new Date().getTime(), portalUserID: PortalUserContext.userContext.id, extendedAttributes: {}})
    onChangeAtPath("/proxyInfo", data)
  }
}

render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    // const { status, view, favoritesData, favoritesForm, selectableFavorites, favoriteMode, glSectionForm, confirmDelete, confirmApply, confirmClear, duplicateTitle, canEdit, canWriteGlobal, error } = this.state
    // var { definition, data, onApplyConditional, onChangeAtPath, onEvaluateConditional, path, policyMessages, preventCollapse, readOnly, showSectionStatusIcon, supressTitle, handleItemDelete } = this.props
    var {data, policyMessages} = this.props

    if (!data || !data.features || (data.features && data.features.length == 0)) {
        return null
    }

    data.proxies.forEach((p:any)=>{
      
      if (p.id == 0) {
        p.id = undefined
      }

      if (policyMessages && policyMessages.length > 0) {
        
        policyMessages.forEach((pm:any)=>{
          var policyIndex
          if (pm.path.indexOf("/proxyInfo/proxies") > -1) {
            var parts = pm.path.split("/")
            policyIndex = parts[parts.length-1]
          }
          if (policyIndex) {
            data.proxies[policyIndex]._proxyToUserIDMissing = true
          }
        })
      }

    })

    return (
        <div className={classes.container}>

                <Typography style={{color: "#555", marginBottom: 20}} variant="h6" >Proxies</Typography>

                <div style={{marginLeft: 10}}>
                  {data.proxies && data.proxies.map((p:any, idx)=>{
                      return (
                          <ProxyFeatureAssignment userType={PortalUserContext.userContext.userType} idx={idx} key={idx} proxy={p} proxies={data.proxies} features={data.features} onProxyChange={this.onProxyChange}></ProxyFeatureAssignment>
                        )
                  })}
                </div>
                

                {!data.proxies || data.proxies.filter((p: any) => { return !p.extendedAttributes["_delete"] }).length == 0 &&
                  <EmptySet classes={{}} text="No proxies have been provided" />
                }

                <Button
                    variant="contained"
                    color="primary"
                    className={classes.addNewProxyButton}
                    onClick={this.newProxy}
                    disabled={false}
                  >
                    Add New
							</Button>
        </div>
    )
   
   
  }
}

export default withStyles(styles)(FeatureProxyAssignment);
